<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>屈光状态计算器</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 屈光状态计算器 start -->
      <el-tab-pane label="屈光状态计算器" name="first">
        <el-form :model="myForm" ref="myFormRef" label-width="68px">
          <el-form-item label="用户年龄" class="addAdminForm">
            <el-input v-model="myForm.age" placeholder="请输入用户年龄"></el-input>
          </el-form-item>
          <el-form-item label="设备类型" class="addAdminForm">
            <el-select v-model="myForm.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 屈光度 -->
          <el-table :data="diopterData" border stripe class="mt20">
            <el-table-column label="屈光度" align="center">
              <el-table-column label="OD(右眼)" align="center">
                <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="myForm.righteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="myForm.rightcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="OS(左眼)" align="center">
                <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="myForm.lefteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="myForm.leftcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 裸眼和矫正视力 -->
          <el-table :data="nakedEye" border stripe class="mt20">
            <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
              <template slot-scope="scope">
                <el-select v-model="myForm.addtype" placeholder="请选择" style="width: 100%">
                  <el-option label="0.00D" value="0"></el-option>
                  <el-option label="0.50D" value="1"></el-option>
                  <el-option label="0.75D" value="2"></el-option>
                  <el-option label="1.00D" value="3"></el-option>
                  <el-option label="1.25D" value="4"></el-option>
                  <el-option label="1.50D" value="5"></el-option>
                  <el-option label="1.75D" value="6"></el-option>
                  <el-option label="2.00D" value="7"></el-option>
                  <el-option label="2.25D" value="8"></el-option>
                  <el-option label="2.50D" value="9"></el-option>
                  <el-option label="2.75D" value="10"></el-option>
                  <el-option label="3.00D" value="11"></el-option>
                  <el-option label="3.25D" value="12"></el-option>
                  <el-option label="3.50D" value="13"></el-option>
                  <el-option label="3.75D" value="14"></el-option>
                  <el-option label="4.00D" value="15"></el-option>
                  <el-option label="4.25D" value="16"></el-option>
                  <el-option label="4.50D" value="17"></el-option>
                  <el-option label="4.75D" value="18"></el-option>
                  <el-option label="5.00D" value="19"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="最佳矫正视力(5分记录法)" align="center">
              <el-table-column prop="odRight1" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="myForm.correctrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft1" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="myForm.correctlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-form-item class="mt20">
            <el-button type="primary" @click="clickCalculator">计算</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 屈光状态计算器 end -->

      <ul>
        <li>视光参数：{{Shiguangcanshu}}</li>
        <li>计算结果：{{DiopterStateName}}</li>
        <li>详细描述：{{Describe}}</li>
      </ul>
    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyDiopterStateCalculator',
  data () {
    return {
      activeName: 'first',
      Shiguangcanshu: '',
      DiopterStateName: '',
      DiopterStateName: '',
      Describe: '',
      bomSnList: [],
      // 提交表单
      myForm: {
        age: '',
        bomsn: '103-0000-0002',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        addtype: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0'
      },
      //
      diopterData: [
        {
          rightEye1: '右眼',
          rightEye2: '右眼',
          rightEye3: '右眼',
          leftEye1: '右眼',
          leftEye2: '右眼',
          leftEye3: '右眼'
        }
      ],
      // ADD和调节幅度
      addData: [
        {
          add: 'add',
          adjust: '调节幅度'
        }
      ],
      // 裸眼和矫正视力
      nakedEye: [
        { odRight: '请选择', osLeft: '请选择', ouDouble: '请选择', odRight1: '请选择', osLeft1: '请选择', ouDouble1: '请选择' }
      ],
      eyedegreelist: [
        { value: '0', label: '请选择' },
        { value: '3.5', label: '3.5' },
        { value: '3.6', label: '3.6' },
        { value: '3.7', label: '3.7' },
        { value: '3.8', label: '3.8' },
        { value: '3.9', label: '3.9' },
        { value: '4.0', label: '4.0' },
        { value: '4.1', label: '4.1' },
        { value: '4.2', label: '4.2' },
        { value: '4.3', label: '4.3' },
        { value: '4.4', label: '4.4' },
        { value: '4.5', label: '4.5' },
        { value: '4.6', label: '4.6' },
        { value: '4.7', label: '4.7' },
        { value: '4.8', label: '4.8' },
        { value: '4.9', label: '4.9' },
        { value: '5.0', label: '5.0' },
        { value: '5.1', label: '5.1' },
        { value: '5.2', label: '5.2' },
        { value: '5.3', label: '5.3' }
      ]
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
      }
    })
  },
  methods: {
    clickCalculator () {
      this.apiDiopterStateCalculator()
    },
    apiDiopterStateCalculator: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        age: that.myForm.age,
        bomsn: that.myForm.bomsn,
        righteyedegree: that.myForm.righteyedegree,
        rightcolumnmirror: that.myForm.rightcolumnmirror,
        lefteyedegree: that.myForm.lefteyedegree,
        leftcolumnmirror: that.myForm.leftcolumnmirror,
        addtype: that.myForm.addtype,
        correctrighteyedegree: that.myForm.correctrighteyedegree,
        correctlefteyedegree: that.myForm.correctlefteyedegree
      }
      that.Shiguangcanshu = '年龄:'+that.myForm.age
      + ';bomsn:'+that.myForm.bomsn
      +";右眼球镜:"+that.myForm.righteyedegree
      +";右眼柱镜:"+that.myForm.rightcolumnmirror
      +";左眼球镜:"+that.myForm.lefteyedegree
      +";左眼柱镜:"+that.myForm.leftcolumnmirror
      +";ADD:"+that.myForm.addtype
      +";右眼最佳矫正视力:"+that.myForm.correctrighteyedegree
      +";左眼最佳矫正视力:"+that.myForm.correctlefteyedegree
      that.DiopterStateName = ''
      that.Describe = ''
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DiopterStateCalculator, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data)
          if (response.data.Code == 200){
            that.DiopterStateName = response.data.DiopterStateName
            that.Describe = response.data.Describe
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
